import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";
import { Divider, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import "../quill.css";
interface IContent {
  title?: string;
  content: string;
}

const useStyles = makeStyles({
  root: {
    margin: "1em",
    padding: "1em",
  },
  padding: {
    padding: "1em",
  },
});
const Content: React.FC<IContent> = ({ title, content }) => {


  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      {title && (
        <>
          <Typography color="primary" variant="h5">
            {t(title)}
          </Typography>

          <Divider />
        </>
      )}
      <Box
        className={classes.padding}
        dangerouslySetInnerHTML={{ __html: content }}
      ></Box>
    </Paper>
  );
};

export default React.memo(Content);
